module.exports = __webpack_public_path__ + "img/wRatings-2021-TM-transparent-1-2.1c692a57.png";